import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {COMMAND_PRIORITY_LOW} from 'lexical';
import {isMimeType, mediaFileReader} from '@lexical/utils';
import {DRAG_DROP_PASTE} from '@lexical/rich-text';
import {useEffect} from 'react';
import {INSERT_IMAGE_COMMAND} from './commands';
import {ACCEPTABLE_TYPES} from './constants';
import {checkImageSize} from '../../../../../../EmailEditor/utils/checkHtmlSize';

export function DragDropPaste({
    isDraggable,
    shouldCheckSize = false
}: {
    isDraggable?: boolean;
    shouldCheckSize?: boolean;
}): null {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerCommand(
            DRAG_DROP_PASTE,
            files => {
                (async () => {
                    const filesResult = await mediaFileReader(files, ACCEPTABLE_TYPES);

                    for (const {file, result} of filesResult) {
                        const isBiggerThanMaxSize =
                            shouldCheckSize && checkImageSize(result, file.name, file.size);
                        if (!isBiggerThanMaxSize && isMimeType(file, ACCEPTABLE_TYPES)) {
                            editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
                                altText: file.name,
                                src: result,
                                isDraggable
                            });
                        }
                    }
                })();
                return true;
            },
            COMMAND_PRIORITY_LOW
        );
    }, [editor]);
    return null;
}
